(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
     if (sessionStorage.getItem("record") == null ){    
   		setTimeout(function(){
            $('.popup_mask').addClass('popup_mask_show');

        },1000);
  	}

	$('.popup_close').click(function(){ 
    	$('.popup_mask').removeClass('popup_mask_show'); 
		sessionStorage.setItem("record", "start_up");
    });

	 var myDate = new Date;
      var h = myDate.getHours();
      if( h > 9 && h < 21 ){
        $('.popup_telephone').attr("href","https://wa.me/message/RQRV4EEQ7JVSG1");

      }else {
        $('.popup_telephone').attr("href","https://wa.me/message/GRQIHSJAISC6G1");
      }
	

  } catch(e) { console.error(e); }
})();
})();
